import { useEffect } from 'react'

import type { ClassResponse } from '@space-shell/common/services/viewAs/types'
import { REDIRECT_ORIGIN_PARAM } from '@space-shell/constant/redirect'
import { useViewAsStore } from '@space-shell/core/store'
import { useSearchParams } from 'react-router-dom'

const useSelectCurrentClassItem = (classes?: ClassResponse[]) => {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const getClassItemFromLegacyClub = () => {
      if (searchParams.get('origin') === REDIRECT_ORIGIN_PARAM) {
        const classHash = searchParams.get('classHash') ?? ''

        if (classHash) {
          return classes?.find((item) => item.hash === classHash)
        }
      }

      return undefined
    }

    const getDefaultClassItem = () => {
      return classes?.find((item) => item.defaultClass)
    }

    if (classes && classes.length > 0) {
      const currentClassItem = getClassItemFromLegacyClub() ?? getDefaultClassItem()

      if (currentClassItem) {
        useViewAsStore.setState({ classItem: currentClassItem })
      }
    }
  }, [classes, searchParams])
}

export { useSelectCurrentClassItem }
